module.exports = __webpack_public_path__ + "fonts/roboto-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/roboto-regular-webfont.woff2
// module id = 3455
// module chunks = 0